/* LAYAM shop grid — progressive enhancement only.

   Everything here degrades cleanly: without JS the add buttons are real
   <form> POSTs to /cart/add, the "Choose size" control is a real link to the
   product page, and the sort <select> falls back to a visible Apply button.
*/
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Sort: auto-submit on change (noscript users get the Apply button) ---- */
  document.querySelectorAll('[data-lys-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      sel.form.submit();
    });
  });

  /* ---- Multi-variant: expand an inline picker instead of navigating ---- */
  /* Multi-variant picker. Desktop: inline expansion in the card. Mobile:
     the options node PORTALS to <body> and opens as a bottom sheet -- fixed
     positioning inside the card is unreliable because reveal animations
     leave transforms on ancestors, which hijack the containing block. */
  var sheetMedia = window.matchMedia('(max-width: 749px)');
  var closeOpenPicker = null;

  document.querySelectorAll('[data-lyc-pick]').forEach(function (pick) {
    var trigger = pick.querySelector('[data-lyc-choose]');
    var opts = pick.querySelector('[data-lyc-opts]');
    if (!trigger || !opts) return;

    var placeholder = document.createComment('lyc-opts');
    var scrim = null;

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-expanded', 'false');

    function close() {
      if (opts.hasAttribute('hidden')) return;
      opts.setAttribute('hidden', '');
      opts.classList.remove('is-sheet');
      if (placeholder.parentNode) {
        placeholder.parentNode.replaceChild(opts, placeholder);
      }
      if (scrim) { scrim.remove(); scrim = null; }
      document.body.classList.remove('lyc-lock');
      pick.classList.remove('is-open');
      trigger.hidden = false;
      trigger.setAttribute('aria-expanded', 'false');
      if (closeOpenPicker === close) closeOpenPicker = null;
    }

    function open() {
      if (closeOpenPicker) closeOpenPicker(); // one picker at a time
      opts.removeAttribute('hidden');
      pick.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      if (sheetMedia.matches) {
        opts.parentNode.insertBefore(placeholder, opts);
        document.body.appendChild(opts);
        opts.classList.add('is-sheet');
        scrim = document.createElement('div');
        scrim.className = 'lyc-scrim';
        scrim.addEventListener('click', close);
        document.body.insertBefore(scrim, opts);
        document.body.classList.add('lyc-lock');
      } else {
        trigger.hidden = true;
      }
      closeOpenPicker = close;
      var first = opts.querySelector('button.lyc__opt:not(:disabled)');
      if (first) first.focus();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (opts.hasAttribute('hidden')) open();
    });

    var closeBtn = opts.querySelector('[data-lyc-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    opts.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); trigger.focus(); }
    });

    // A successful add from inside the picker closes it after the "Added"
    // flash has registered, handing the eye to the toast and cart pulse.
    opts.addEventListener('lyc:added', function () {
      window.setTimeout(close, 550);
    });
  });

  /* ---- Add to cart without a page navigation ---- */
  function refreshCartCount() {
    // Ask the theme for a fresh cart bubble and swap it in.
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + '?section_id=cart-icon-bubble'
      : '/?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('.shopify-section');
        var live = document.getElementById('cart-icon-bubble');
        if (fresh && live) {
          var inner = fresh.querySelector('#cart-icon-bubble');
          if (inner) live.innerHTML = inner.innerHTML;
        }
      })
      .catch(function () { /* bubble is cosmetic; ignore */ });
  }

  function flash(btn, label, success) {
    var original = btn.innerHTML;
    if (success) {
      /* Forest fill + a checkmark that draws itself: state change you can
         see land, not just a text swap. */
      btn.classList.add('is-added');
      btn.innerHTML =
        '<svg class="lyc__check" viewBox="0 0 24 24" width="18" height="18" fill="none" ' +
        'stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M4 12.5l5.5 5.5L20 6.5"/></svg><span>' + label + '</span>';
    } else {
      btn.innerHTML = '<span>' + label + '</span>';
    }
    window.setTimeout(function () {
      btn.innerHTML = original;
      btn.classList.remove('is-added');
    }, 1500);
  }

  /* Fly-to-cart: a small clone of the product photo arcs from the card into
     the cart bar (mobile) or the header cart chip. The image ref is captured
     at bind time -- sheet forms get portaled to <body> later, where
     closest('.lyc') would come up empty. */
  function flyToCart(img) {
    var done = Promise.resolve();
    if (!img || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return done;
    var targetEl = null;
    var bar = document.querySelector('[data-la-cartbar]');
    if (bar && !bar.hidden && getComputedStyle(bar).display !== 'none') {
      targetEl = bar.querySelector('[data-cb-thumb]') || bar;
    } else {
      targetEl = document.getElementById('cart-icon-bubble');
    }
    if (!targetEl) return done;
    var from = img.getBoundingClientRect();
    var to = targetEl.getBoundingClientRect();
    if (!from.width || (!to.width && !to.height)) return done;
    var fly = img.cloneNode(false);
    fly.className = 'la-flyer';
    fly.style.left = from.left + 'px';
    fly.style.top = from.top + 'px';
    fly.style.width = from.width + 'px';
    fly.style.height = from.height + 'px';
    document.body.appendChild(fly);
    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    var anim = fly.animate([
      { transform: 'translate(0, 0) scale(1) rotate(0deg)', opacity: 1, borderRadius: '12px' },
      { transform: 'translate(0, -6px) scale(1.05) rotate(0deg)', opacity: 1, borderRadius: '12px', offset: 0.12 },
      { transform: 'translate(' + dx * 0.5 + 'px, ' + (dy * 0.5 - 80) + 'px) scale(0.5) rotate(-5deg)', opacity: 0.95, offset: 0.55 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.15) rotate(0deg)', opacity: 0.3, borderRadius: '999px' }
    ], { duration: 700, easing: 'cubic-bezier(0.3, 0.1, 0.3, 1)' });
    return new Promise(function (resolve) {
      var finish = function () {
        if (fly.parentNode) fly.remove();
        /* landing impact on the target */
        if (targetEl.animate) {
          targetEl.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }],
            { duration: 320, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }
          );
        }
        /* one soft haptic tick where supported (Android); iOS ignores it */
        if (navigator.vibrate) { try { navigator.vibrate(12); } catch (err) {} }
        resolve();
      };
      anim.onfinish = finish;
      setTimeout(finish, 1000); /* safety if onfinish never fires */
    });
  }

  document.querySelectorAll('[data-lyc-form]').forEach(function (form) {
    var cardImg = (function () {
      var card = form.closest('.lyc');
      return card ? card.querySelector('.lyc__img') : null;
    })();
    form.addEventListener('submit', function (e) {
      // If fetch is unavailable let the browser do the normal POST.
      if (!window.fetch) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');

      fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.classList.remove('is-busy');
          if (data && data.status) {
            // Shopify returned an error (e.g. out of stock) — fall back to
            // the product page rather than failing silently.
            flash(btn, 'Unavailable');
            return;
          }
          flash(btn, 'Added', true);
          var card = btn.closest('.lyc') || (cardImg && cardImg.closest('.lyc'));
          if (card) {
            card.classList.remove('is-sent');
            void card.offsetWidth;
            card.classList.add('is-sent');
            setTimeout(function () { card.classList.remove('is-sent'); }, 800);
          }
          var host = form.closest('[data-lyc-opts]');
          if (host) host.dispatchEvent(new CustomEvent('lyc:added'));
          var resolved = false;
          var announce = function () {
            if (resolved) return;
            resolved = true;
            document.dispatchEvent(new CustomEvent('la:toast', {
              detail: { msg: (data.product_title || 'Item') + ' added' }
            }));
            refreshCartCount();
          };
          /* The bar/chip reacts when the flyer LANDS, so cause and effect
             read as one continuous motion instead of everything at once. */
          flyToCart(cardImg).then(announce);
          setTimeout(announce, 1200); /* never let feedback hang on a lost promise */
        })
        .catch(function () {
          // Network trouble: hand control back to the real form POST.
          btn.classList.remove('is-busy');
          form.submit();
        });
    });
  });
})();
